import React, { useEffect, useState } from "react";
import { ROUTES } from "../utils/Routes";
import VirtualTable from "../ui/VirtualTable";
import Float from "../ui/Float";
import { bm_date, kbdEvent } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import Spin from "../ui/Spin";
import ReleaseNotes from "./ReleaseNotes";

export default function HomeStations(props) {

    const { controller = "", signal = {}, state = {}, setState = () => { } } = props;
    const row_key = "number";
    const [loading, setLoading] = useState(false);
    const [stations, setStations] = useState([]);
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("start");

    const fetchWorkstations = () => {
        setLoading(true)
        pubCall("work_station.getAll", {initial : false}, (_s, _r) => {
            setLoading(false);
            if (_s) {
                setStations(_r);
                setSelected(_r?.[0] || {})
            } else {
                showError(_r);
            }
        })
    }

    useEffect(fetchWorkstations, []);

    let station_columns = [
        { key: "number", title: <>#</>, align: "center", width: 35 },
        { key: "active", title: <>Live</>, align: "center", width: 35, render: (e) => { return (e) ? <span style={{ "color": "var(--text-green)" }}>•</span> : "" } },
        {
            key: "last_active", title: <>Last Active</>, align: "left", width: 90, render: (e) => {
                return (e) ? <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span> : "";
            }
        },
        { key: "name", title: <>Name</>, align: "left", width: 1, grow: true },
    ]

    const next = (_rows = 1) => {

       
        if (stations.length === 0) { setSelected({}); return; }
        setAlign("auto");
        const nextIndex = stations.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
         console.log(nextIndex)
        if (stations.length <= nextIndex) {
            setSelected(stations[stations.length - 1]);
        }
        if (nextIndex < stations.length) {
            setSelected(stations[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (stations.length === 0) { setSelected({}); return; }
        const prevIndex = stations.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(stations[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(stations[prevIndex]);
        }
    };

    const filterStations = () => {
        return stations.filter(item => {
            if (state.station.active) {
                return true;
            } else {
                return item.active
            }
        })
    }

    return (
        <Spin loading={loading}>
          
            <VirtualTable
                controller={controller}
                header={<div style={{ "fontSize": "14px" }}><Float><div>Active Stations ({stations.filter(item => item.active).length})</div><span className="text-yellow">[R]eview 1 orders (40 days old) &nbsp;</span></Float></div>}
                showColumnHeaders={false}
                scrollbar={true}
                scrollindicator={true}
                row_key={row_key}
                next={(_rows) => next(_rows, filterStations(), state.station)}
                prev={(_rows) => prev(_rows, filterStations(), state.station)}
                onRowClick={(item) => {
                    setTimeout(() => {
                        setState({ ...state, ["station"]: { ...state["station"], "selected": item } });
                    }, 10)
                }}
                onRowDoubleClick={() => alert("double click")}
                route={ROUTES.HOME.STATIONS}
                no_header_borders={(state.station.active) ? "" : true}
                current={selected}
                data={filterStations()}
                width={0}
                height={540}
                offset={150}
                columns={station_columns}
            />
        </Spin>
    )
}


